import React, { useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import Sidebar from "../../components/sidebar";
import AlertReceived from "../../components/field_alerts/AlertReceived";
import { Container, SideContainer } from "../main_display/styles";

const ScrollSide = styled(SideContainer)`
  overflow-x: hidden !important;
  overflow-y: auto !important;
  -webkit-overflow-scrolling: touch;
`;

export default function AlertReceivedPage() {
  const collapsed = useSelector((state) => state.sidebar);
  const [localCollapsed, setLocalCollapsed] = useState(false);

  return (
    <Container>
      <Sidebar
        collapsed={localCollapsed.toString()}
        setCollapsed={setLocalCollapsed}
      />
      <ScrollSide collapsed={(collapsed || localCollapsed).toString()}>
        <AlertReceived />
      </ScrollSide>
    </Container>
  );
}
